import global from "./global.json";

export const fr = {
  global,
};
